import { Logger } from '@quickplay/foundation';
import { MediatailorAdHandlerImpl } from './DefaultMediatailorAdHandler';
import { Player } from '@quickplay/player-interface';
import { MediatailorAdHandlerMetadata } from '../../model/AdMetadata';

export const MediatailorFactory = {
  createMediatailorAdHandler(
    player: Player,
    mediatailorAdHandlerMetadata: MediatailorAdHandlerMetadata,
    logger: Logger,
  ): MediatailorAdHandlerImpl {
    return new MediatailorAdHandlerImpl(player, mediatailorAdHandlerMetadata, logger);
  },
};
